import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableRoles from './libraries';

export const PageRolesComponent = (props: any) => {
    const title = 'Roles';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/user/roles">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableRoles />
        </LayoutCMS>
    );
};

export default PageRolesComponent;



// WEBPACK FOOTER //
// ./src/pages/roles/component.tsx